import { Type } from '@sinclair/typebox';
import { createClientError } from '../core/create-client-error.js';
export const SharePointProvisioningBusyError = createClientError('SHAREPOINT_PROVISIONING_BUSY', Type.Object({}));
